// Field details modal props
export interface IFieldDetailsModalProps {
  fieldId: string;
  handleClose: () => void;
}

export interface IField {
  id: string;
  seqId: number;
  name: string;
  complianceStatus: string;
  approvalStatus: string;
  overlapStatus: string;
  date: string;
  province: string;
  subDistrict: string;
  district: string;
  address: string;
  village: string | null;
  postalCode: number;
  fieldIdentificationNumber: string;
  factoryId: string;
  farmerId: string;
  farmerName: string;
  farmerLastName: string;
  farmerSeqId: number;
  farmerInternalId: string;
  farmerMediaFileId: string | null;
  fieldArea: number;
  fieldAreaUser: number;
  fieldAreaUserUnit: string;
  mediaFileId: string | null;
  mapFileId: string | null;
  boundary: IBoundary;
  centroid: any | null; // Define a more precise type if centroid data is available
  agentId: string;
  agentSeqId: number;
  landTypeId: string;
  landName: string;
  activeCycles: ICropCycle[];
  pastCycles: ICropCycle[];
  // R4a — nested dealer / branch / vendor summaries + resolved direct seller
  dealer: IDealerSummary | null;
  branch: IBranchSummary | null;
  vendor: IDealerSummary | null;
  directSellerName: string | null;
  directSellerType: "dealer" | "vendor" | null;
  // R7 — this field's own estimated monthly + annual yield/quota.
  yieldSummary: IYieldSummary | null;
}

// R7 — monthly (Jan–Dec) + annual yield/quota for a single field.
export interface IYieldSummary {
  jan: number;
  feb: number;
  mar: number;
  apr: number;
  may: number;
  jun: number;
  jul: number;
  aug: number;
  sep: number;
  oct: number;
  nov: number;
  dec: number;
  year: number;
}

// Ordered month keys (match yieldConfig.months.* i18n keys + IYieldSummary).
export type TYieldMonthKey = keyof Omit<IYieldSummary, "year">;

// Months grouped 4-per-row for the slider's matrix table (month-name row +
// value row per group): Jan–Apr, May–Aug, Sep–Dec.
export const YIELD_MONTH_ROWS: TYieldMonthKey[][] = [
  ["jan", "feb", "mar", "apr"],
  ["may", "jun", "jul", "aug"],
  ["sep", "oct", "nov", "dec"],
];

// Months split into two rows of six (Jan–Jun, Jul–Dec) — used by the wider
// Field Details page where the monthly distribution reads as two rows.
export const YIELD_MONTH_ROWS_HALVES: TYieldMonthKey[][] = [
  ["jan", "feb", "mar", "apr", "may", "jun"],
  ["jul", "aug", "sep", "oct", "nov", "dec"],
];

// R4a — nested summaries returned on the field details response
export interface IDealerSummary {
  id: string;
  dealerId: string;
  dealerName: string;
}

export interface IBranchSummary {
  id: string;
  branchId: string;
  name: string;
}

export interface IBoundary {
  type: string;
  geometry: {
    type: string;
    coordinates: number[][][];
  };
  properties: {
    id: number;
    area: number;
  };
}

export interface ICropCycle {
  id: string;
  status: string;
  cropName: string;
  startDate: string;
  harvestDate: string | null;
}
